"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

exports.SVG = function () {
  return react_1["default"].createElement("svg", {
    viewBox: "0 0 20 20",
    fill: "none"
  }, react_1["default"].createElement("path", {
    d: "M18 4C18 2.896 17.104 2 16 2C14.896 2 14 2.896 14 4C14 4.48 14.177 4.916 14.459 5.261L12.67 10.033C12.263 10.102 11.896 10.289 11.612 10.563L7.934 9.513C7.715 8.645 6.936 8 6 8C4.896 8 4 8.896 4 10C4 10.508 4.195 10.966 4.507 11.318L3.6 14.041C2.687 14.226 2 15.033 2 16C2 17.104 2.896 18 4 18C5.104 18 6 17.104 6 16C6 15.492 5.805 15.034 5.493 14.682L6.4 11.959C6.78 11.882 7.119 11.696 7.388 11.437L11.066 12.488C11.285 13.355 12.064 14 13 14C14.104 14 15 13.104 15 12C15 11.52 14.823 11.084 14.541 10.739L16.331 5.967C17.277 5.809 18 4.991 18 4Z",
    fill: "#727B7F"
  }));
};